/**
 * Mapping from `tuning_options.key` → static PNG icon path under
 * `/icons/options/`. Kept in a separate file so both the New Order page
 * and the Order Detail drawer reference one source of truth.
 */
export const OPTION_ICONS = {
  dpf_fap_delete:                            'Group-10.png',
  opf_gpf_full_deactivation:                 'Group-10.png',
  egr_agr_removal:                           'Group-11.png',
  nox_off:                                   'Group-205.png',
  scr_adblue_off:                            'Group-19.png',
  full_decat_second_lambda_deactivation:     'Group-9.png',
  diesel_engines_lambda_removal:             'Group-9.png',
  speed_limiter_vmax_modify:                 'Group-21.png',
  stage_1_tuning_file:                       'Group-7.png',
  stage_1_stage_2_tuning_file:               'Group-7.png',
  stage_3_tuning_file:                       'Group-7.png',
  throttle_valve_tva_disable:                'Group-200.png',
  swirl_valve_flaps_off:                     'Group-200.png',
  back_pressure_sensor_b60_off:              'Group-200.png',
  evap_system_disable:                       'group204.png',
  secondary_system_disable:                  'group204.png',
  exhaust_flap_disable:                      'Group-12.png',
  maf_off:                                   'maf.png',
  glow_plug_monitoring_off:                  'glow.png',
  dtc_s_selectivity_off:                     'Group-16-1.png',
  dsg_dq200_gearbox_tuning:                  'Group-13.png',
  dsg_dq250_gearbox_tuning:                  'Group-13.png',
  dq500_gearbox_tuning:                      'Group-13.png',
  dl501_gearbox_tuning:                      'Group-13.png',
  dq250mqb_dq380_dq381_dl382_gearbox_tuning: 'Group-13.png',
  v30_vl300_gearbox_tuning:                  'Group-13.png',
  dl800_porsche_pdk_gearbox_tuning:          'Group-13.png',
  gearbox_zf_8hp_al551_al552_al951_ford_gm_10_speed: 'Group-13.png',
  start_stop_off:                            'Group-20.png',
  readiness_codes_monitors_ready:            'Group-201.png',
  full_immo_off_eprom:                       'group202.png',
  cvn_fix_warranty_patch:                    'Group-2031.png',
  pop_bang_hard_cut_limiter_popcorn:         'Group-15.png',
  e85_flex_fuel_adaptation:                  'E85-1.png',
};

export const optionIconUrl = (key) => {
  const file = OPTION_ICONS[key];
  return file ? `/icons/options/${file}` : null;
};
